import React from "react";
import { useTranslation } from "../../langs/useTranslation";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField,
  Grid,
  Checkbox,
  Button
} from "@material-ui/core";
import useStyles from "../../styles/dialogStyle";
import { BackBtn } from "../../components/commons/FormBtns";
import DeleteIcon from "@material-ui/icons/Delete";
import { DatePicker, TimePicker } from "@material-ui/pickers";
import windowsIcon from "../../assets/images/windows.svg";
import androidIcon from "../../assets/images/android.svg";
import Tooltip from "@material-ui/core/Tooltip";
// import HasPermission from "../commons/HasPermission";
import SubmitButton from "../commons/SubmitButton";
import MemoedHOC from "@/hoc/MemoedHOC";

const AddEventDialog = props => {
  const classes = useStyles();

  const {
    open,
    readOnly,
    time,
    setTime,
    onClose,
    onConfirmAdd,
    onConfirmEdit,
    task,
    setTask,
    deleteHandler,
    timeInLocal,
    dotColor,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loading,
    endType,
    setEndType,
    times,
    setTimes,
    loopType,
    editData,
    setLoopType,
    dailyType,
    setDailyType,
    dailyTimes,
    setDailyTimes,
    weeklyTimes,
    setWeeklyTimes,
    weeklySelect,
    setWeeklySelect
  } = props;
  const { t } = useTranslation("powerManagement");

  const handleChange = event => {
    setWeeklySelect({
      ...weeklySelect,
      [event.target.name]: event.target.checked
    });
  };

  const taskMap = [
    {
      value: "start",
      text: t("dialog.powerOn"),
      type: "windows"
    },
    {
      value: "shutdown",
      text: t("dialog.powerOff"),
      type: "windows"
    },
    {
      value: "open_screen",
      text: t("dialog.wakeUp"),
      type: "android"
    },
    {
      value: "close_screen",
      text: t("dialog.sleep"),
      type: "android"
    },
    {
      value: "reboot",
      text: t("dialog.reboot"),
      type: "both"
    }
  ];

  return (
    <Dialog
      maxWidth="lg"
      className={classes.dialog}
      open={open}
      aria-labelledby="add-event-dialog"
      aria-describedby="add-event-dialog"
    >
      <DialogTitle id="add-edit-alarm-notification">
        {editData && editData.event ? (
          <div className={classes.eventOuter}>
            <div
              className={classes.dot}
              style={{
                marginRight: "5px",
                background: dotColor(editData.event.extendedProps.task_type)
              }}
            ></div>
            <div className={classes.eventTime}>
              {timeInLocal(editData.event.borderColor)} {editData.event.title}
            </div>
          </div>
        ) : (
          t({ defaultMessage: "排程任务" })
        )}
      </DialogTitle>
      <>
        <DialogContent>
          <div className={classes.inputArea}>
            <Typography
              variant="subtitle1"
              style={{ marginTop: "7px" }}
              className="fixWidth"
            >
              1. {t("dialog.selectTask")}
            </Typography>
            <div className={classes.radioWithInput}>
              <RadioGroup
                aria-label="selectTask"
                value={task}
                onChange={event => setTask(event.target.value)}
              >
                <div className={classes.radioArea}>
                  {taskMap.map(e => (
                    <FormControl key={e.value} disabled={loading || readOnly}>
                      <FormControlLabel
                        value={e.value}
                        control={<Radio color="primary" />}
                        label={
                          <div className={classes.radioWithOS}>
                            <div className={classes.radioWithOSText}>
                              {e.text}
                            </div>
                            {e.type === "windows" && (
                              <Tooltip title="For Windows" placement="top">
                                <img
                                  width="20"
                                  height="20"
                                  src={windowsIcon}
                                  alt="windowsIcon"
                                />
                              </Tooltip>
                            )}
                            {e.type === "android" && (
                              <Tooltip title="For Android" placement="top">
                                <img
                                  width="20"
                                  height="20"
                                  src={androidIcon}
                                  alt="androidIcon"
                                />
                              </Tooltip>
                            )}
                            {e.type === "both" && (
                              <>
                                <Tooltip title="For Windows" placement="top">
                                  <img
                                    style={{ marginRight: "10px" }}
                                    width="20"
                                    height="20"
                                    src={windowsIcon}
                                    alt="windowsIcon"
                                  />
                                </Tooltip>
                                <Tooltip title="For Android" placement="top">
                                  <img
                                    width="20"
                                    height="20"
                                    src={androidIcon}
                                    alt="androidIcon"
                                  />
                                </Tooltip>
                              </>
                            )}
                          </div>
                        }
                      />
                    </FormControl>
                  ))}
                </div>
              </RadioGroup>
            </div>
          </div>
          {/* <Typography
            variant="body2"
            color="error"
            className={classes.warnText}
          >
            {t("dialog.osWarn")}
          </Typography> */}
          <div className={classes.inputArea}>
            <Typography className="fixWidth" variant="subtitle1">
              2. {t({ defaultMessage: "循环模式" })}
            </Typography>
            <div className={classes.datePicker} style={{ marginLeft: "0" }}>
              <RadioGroup
                className="loopTypeSelect"
                aria-label="date"
                value={loopType}
                onChange={e => setLoopType(e.target.value)}
              >
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl>
                      <FormControlLabel
                        disabled={readOnly}
                        value="daily"
                        style={{ width: "50px" }}
                        control={<Radio color="primary" />}
                        label={<div>{t("dialog.dailyText")}</div>}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl>
                      <FormControlLabel
                        disabled={readOnly}
                        value="weekly"
                        style={{ width: "50px" }}
                        control={<Radio color="primary" />}
                        label={<div>{t("dialog.weeklyText")}</div>}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </RadioGroup>
              <div className="loopType">
                {loopType === "daily" ? (
                  <RadioGroup
                    aria-label="date"
                    value={dailyType}
                    onChange={e => setDailyType(e.target.value)}
                  >
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl>
                          <FormControlLabel
                            disabled={readOnly}
                            value="every"
                            control={<Radio color="primary" />}
                            label={
                              <div className="flex_center">
                                <div className="mr-2">
                                  {t("dialog.everyText")}
                                </div>
                                <div>
                                  <TextField
                                    disabled={readOnly}
                                    value={dailyTimes}
                                    type="number"
                                    onChange={e =>
                                      setDailyTimes(e.target.value)
                                    }
                                    onFocus={() => setDailyType("every")}
                                    style={{ width: "60px" }}
                                    inputProps={{ min: 1 }}
                                  />
                                </div>
                                <div className="ml-2">
                                  {t("dialog.daysText")}
                                </div>
                              </div>
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl>
                          <FormControlLabel
                            disabled={readOnly}
                            value="every_workdays"
                            control={<Radio color="primary" />}
                            label={<div>{t("dialog.everyWorkDays")}</div>}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div className="weeklyEvery ml-1">
                        <div className="mr-2">{t("dialog.everyText")}</div>
                        <div>
                          <TextField
                            disabled={readOnly}
                            value={weeklyTimes}
                            type="number"
                            onChange={e => setWeeklyTimes(e.target.value)}
                            style={{ width: "60px" }}
                            inputProps={{ min: 1 }}
                          />
                        </div>
                        <div className="ml-2">
                          {t("dialog.weeksText")}
                          {weeklyTimes > 4 && (
                            <Typography
                              color="error"
                              component="span"
                              style={{ marginLeft: 8 }}
                            >
                              {t({ defaultMessage: "输入上限：4" })}
                            </Typography>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div className="ml-1">
                        {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map(
                          e => (
                            <FormControlLabel
                              disabled={readOnly}
                              key={e}
                              control={
                                <Checkbox
                                  onChange={handleChange}
                                  name={e}
                                  checked={weeklySelect[e] || false}
                                />
                              }
                              label={t(`dialog.${e}Text`)}
                            />
                          )
                        )}
                      </div>
                    </Grid>
                  </Grid>
                )}
              </div>
            </div>
          </div>
          <div className={classes.inputArea}>
            <Typography className="fixWidth" variant="subtitle1">
              3. {t({ defaultMessage: "执行时间" })}
            </Typography>
            <div className={classes.datePicker}>
              <TimePicker
                ampm={false}
                disabled={loading || readOnly}
                value={time}
                onChange={time => setTime(time)}
                renderInput={props => <TextField {...props} />}
              />
            </div>
          </div>
          <div className={classes.inputArea}>
            <Typography className="fixWidth" variant="subtitle1">
              4. {t({ defaultMessage: "执行期间" })}
            </Typography>
            <div className={classes.datePicker}>
              <DatePicker
                value={startDate}
                disabled={loading || readOnly}
                placeholder={t("dialog.selectDate")}
                onChange={date => setStartDate(date)}
                inputFormat="YYYY/MM/DD"
                minDate={!editData ? new Date() : undefined}
                minDateMessage={t("dialog.minDateMessage")}
                renderInput={props => <TextField {...props} />}
              />
              <RadioGroup
                aria-label="date"
                className="dateGroup"
                value={endType}
                onChange={e => setEndType(e.target.value)}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl className="ml-2">
                      <FormControlLabel
                        disabled={readOnly}
                        value="datetime"
                        control={<Radio color="primary" />}
                        label={
                          <div className="flex_center">
                            <div className="mr-2">
                              {t("dialog.endDateText")}
                            </div>
                            <DatePicker
                              value={endDate}
                              disabled={loading || readOnly}
                              placeholder={t("dialog.selectDate")}
                              onChange={date => setEndDate(date)}
                              inputFormat="YYYY/MM/DD"
                              minDate={new Date()}
                              minDateMessage={t("dialog.minDateMessage")}
                              renderInput={props => <TextField {...props} />}
                              InputProps={{
                                onFocus: () => {
                                  setEndType("datetime");
                                }
                              }}
                            />
                          </div>
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl className="ml-2">
                      <FormControlLabel
                        disabled={readOnly}
                        value="times"
                        control={<Radio color="primary" />}
                        label={
                          <div className="flex_center">
                            <TextField
                              disabled={readOnly}
                              value={times}
                              type="number"
                              onFocus={() => setEndType("times")}
                              onChange={e => setTimes(e.target.value)}
                              style={{ width: "60px" }}
                              inputProps={{ min: 1 }}
                            />
                            <div className="ml-2">
                              {t("dialog.timesText")}
                              {times > 30 && (
                                <Typography
                                  color="error"
                                  component="span"
                                  style={{ marginLeft: 8 }}
                                >
                                  {t({ defaultMessage: "输入上限：30" })}
                                </Typography>
                              )}
                            </div>
                          </div>
                        }
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </RadioGroup>
            </div>
          </div>
        </DialogContent>
        {!readOnly ? (
          <DialogActions className={classes.noMarginBtn}>
            {editData ? (
              <SubmitButton
                color="primary"
                type="button"
                variant="contained"
                loading={loading}
                onClick={() => onConfirmEdit()}
              >
                {t("dialog.confirmBtn")}
              </SubmitButton>
            ) : (
              <SubmitButton
                color="primary"
                type="button"
                variant="contained"
                loading={loading}
                onClick={() => onConfirmAdd()}
              >
                {t("dialog.confirmBtn")}
              </SubmitButton>
            )}
            <BackBtn onClick={onClose} btnText={t("dialog.cancel")} />
            {editData && (
              // <HasPermission permission="power_management_delete_task">
              <Tooltip title={t("dialog.delete")} placement="top">
                <DeleteIcon
                  className="fc-delete"
                  onClick={() => deleteHandler(editData)}
                />
              </Tooltip>
              // </HasPermission>
            )}
          </DialogActions>
        ) : (
          <DialogActions className={classes.noMarginBtn}>
            <Button color="primary" variant="outlined" onClick={onClose}>
              {t({ defaultMessage: "关闭" })}
            </Button>
          </DialogActions>
        )}
      </>
    </Dialog>
  );
};

export default MemoedHOC(AddEventDialog);
